// extracted by mini-css-extract-plugin
export default {"view":"ProcessedRequestsGrid_view__4hYcH"};